<template>
    <b-container fluid class="img-bg">
        <b-row class="w-100 h-75">
            <b-col sm></b-col>
            <b-col sm style="margin:auto;">
                <div>
                    <div class="panel">
                        <div class="sidebar-header">
                            <b-img src="NS_logo.jpg" class="sidebar-logo"/>
                        </div>
                    </div>

                    <div class="panel">
                        <b-form class="welcome-form">
                            <b-form-group>
                                <b-input-group>
                                    <b-input-group-text><b-icon-at></b-icon-at></b-input-group-text>
                                    <b-form-input name="" class="form-control" placeholder="Email" type="email" v-model.trim="loginForm.email"></b-form-input>
                                </b-input-group> <!-- input-group.// -->
                            </b-form-group> <!-- form-group// -->
                            <b-form-group>
                                <b-input-group>
                                    <b-input-group-text><b-icon-tag></b-icon-tag></b-input-group-text>
                                    <b-form-input class="form-control" type="text" placeholder="Codice Biglietto" autocomplete="off" v-model.trim="loginForm.ticket"></b-form-input>
                                </b-input-group> <!-- input-group.// -->
                            </b-form-group> <!-- form-group// -->
                            <p v-if="showErrors" class="text-danger text-center">{{showErrors}}</p>
                            <div class="form-group">
                                <b-spinner v-if="logging" variant="primary" label="Spinning" style="margin:auto;"></b-spinner>
                                <b-button v-else type="submit" class="btn btn-primary btn-block" variant="success" @click="login">Accedi al tour</b-button>
                            </div> <!-- form-group// -->
                        </b-form>
                    </div>
                </div>
            </b-col>
            <b-col sm></b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: "HomeTicket",
        data () {
            return {
                loginForm: {
                    email: '',
                    ticket: ''
                },
                errors: null,
                logging: false
            }
        },
        computed: {
            showErrors () {
                return this.errors
            }
        },
        methods: {
            login: function () {
                this.logging = true;
                try {
                    let isTicketValid = this.$firebase.functions.httpsCallable('isTicketValid');
                    isTicketValid({ticket: this.loginForm.ticket, email: this.loginForm.email}).then(function(result) {
                        console.log(result);
                        if(result.data){
                            this.$router.push({name: 'client_tour', params: { ticket: this.loginForm.ticket } });
                        } else {
                            this.errors = 'Biglietto non trovato';
                            this.logging = false;
                        }
                    }.bind(this)).catch(function(error) {
                        console.log("Error getting document:", error);
                        this.errors = error;
                        this.logging = false;
                    }.bind(this))

                    /*var docRef = this.$firebase.ticketsCollection.doc(this.loginForm.ticket)
                    docRef.get().then(function(doc) {
                        if (doc.exists) {
                            let ticket_details = doc.data();
                            if(this.loginForm.email === ticket_details.user_email){
                                let isvalid = ticket_details.valid & !ticket_details.used;
                                if(isvalid){
                                    this.$router.push({name: 'client_tour', params: { ticket: this.loginForm.ticket } });
                                }
                            }
                        } else {
                            console.log("No such document!");
                        }
                    }.bind(this)).catch(function(error) {
                        console.log("Error getting document:", error);
                    });*/

                } catch (error) {
                    this.errors = error;
                }
            },
            updateLang: function (_lang) {
                console.log(_lang);
            },
        }
    }
</script>

<style scoped>

    .img-bg{
        background-image: url("../../public/ns_bg.jpg");
        background-size: cover;
        background-position: center;
        padding:0;
        height:100%;
        overflow:auto;
    }

    .panel{
        background-color:#fff;
        margin:3px;
        padding:5px;
        border-radius:5px;
    }

    .sidebar-header{
        max-width: 60%;
        margin: auto;
    }

    .sidebar-logo{
        width:100%;
        height:100%;
    }

    .welcome-form{
        padding-top: 10px;
        margin: Auto;
        width: 85%;
    }

</style>
